var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCld2026HeaderUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 144,
    r: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 64 448 c 0 -80, 64 -144, 144 -144 h 96 c 80 0, 144 64, 144 144 v 32 h -384 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCld2026HeaderUser);
export default __webpack_public_path__ + "static/media/cld2026-header-user.0bb24ee6e750c4b1539a17e16e4c74fe.svg";
export { ForwardRef as ReactComponent };